export default "__VITE_ASSET__f7daa990__"